<template>
  <div class="about-us">
    <AboutM />
  </div>
</template>

<script>
import AboutM from '../components/mobile/Aboutus.vue'

export default {
  name: 'aboutus',

  components: {
    AboutM
  },

  props: {
    type: String
  },

  data () {
    return {
    }
  },

  beforeMount () {
  },

  beforeDestroy () {
  },

  methods: {
  }
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// AboutView.vue